import { getPaasPublicDemo } from "@/fixtures/paasPublicDemo";

export function getPaasPlansDemo() {
  return [
    {
      id: 9001,
      name: "Alocacao 2026.1 - Centro de Informatica",
      date: "24/06/2026 18:00:00",
      numberClasses: 5,
      numberRooms: 3,
      share: 1,
      hash: "demo-ci-2026-1",
      queue: false
    },
    {
      id: 9002,
      name: "Ajuste manual de laboratorios",
      date: "20/06/2026 14:30:00",
      numberClasses: 4,
      numberRooms: 2,
      share: 0,
      hash: "demo-labs-2026-1",
      queue: false
    },
    {
      id: 9003,
      name: "Simulacao em processamento",
      date: "24/06/2026 19:10:00",
      numberClasses: 12,
      numberRooms: 7,
      share: 0,
      hash: "demo-processing",
      queue: true
    }
  ];
}

export function getPaasPlanDemo(id) {
  const plan = getPaasPlansDemo().find(item => item.id == id);
  const publicDemo = getPaasPublicDemo();

  return {
    ...plan,
    share: plan?.share || 0,
    hash: plan?.hash || "demo-ci-2026-1",
    solution: {
      ...publicDemo.solution,
      id,
      status: "Ready"
    }
  };
}
